import { culture, timeZone } from './constants';

export const getFormattedDate = (date) => {
    return date ? (date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()) : "";
}

export const getLocalDateString = (date) => {
    return date ? new Date(Date.parse(date)).toLocaleDateString(culture) : "";
}

export const getLocalDateTimeString = (date) => {
    return date ? new Date(Date.parse(date)).toLocaleString(culture) : "";
}

export const getTimeString = (date) => {
    return date ? new Date(Date.parse(date)).toLocaleTimeString(culture) : "";
}

export const getCurrentDate = () => {
    return new Date(new Date().toLocaleString(culture, { timeZone: timeZone }));
}